// src/hooks/useRestaurantMenu.js
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { REST_API_MENU_URL } from "../helpers/Constant";

const useRestaurantMenu = (id) => {
  const locDetails = useSelector((store) => store.location.locationDetails);
  const [latitude, setLatitude] = useState(locDetails?.[0]?.lat);
  const [longitude, setLongitude] = useState(locDetails?.[0]?.lng);
  const [resDetails, setResDetails] = useState(null);
  const [resOffers, setResOffers] = useState([]);
  const [resMenu, setResMenu] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  
  async function getRestaurantMenu() {
    try {
      setLoading(true);
      setError(null);
      
      console.log(`📡 Fetching restaurant menu for ID: ${id}`);
      
      const data = await fetch(REST_API_MENU_URL(latitude, longitude) + id);
      const json = await data.json();
      
      console.log("📦 Restaurant menu response received");
      
      const restaurantData =
        json?.data?.cards
          ?.map((x) => x.card)
          ?.find(
            (x) =>
              x &&
              x.card["@type"] ===
                "type.googleapis.com/swiggy.presentation.food.v2.Restaurant"
          )?.card?.info || null;
          
      const restaurantOffers =
        json?.data?.cards
          ?.map((x) => x.card)
          ?.find(
            (x) =>
              x &&
              x.card["@type"] ===
                "type.googleapis.com/swiggy.gandalf.widgets.v2.GridWidget"
          )
          ?.card?.gridElements?.infoWithStyle?.offers?.map((x) => x?.info) || [];
          
      const restaurantMenu =
        json?.data?.cards
          ?.find((x) => x.groupedCard)
          ?.groupedCard?.cardGroupMap?.REGULAR?.cards?.map((x) => x?.card?.card)
          .filter(
            (x) =>
              x["@type"] ===
              "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory"
          ) || [];
          
      setResDetails(restaurantData);
      setResOffers(restaurantOffers);
      setResMenu(restaurantMenu);
    } catch (error) {
      console.error("❌ Error fetching restaurant menu:", error);
      setError("Failed to load restaurant menu");
    } finally {
      setLoading(false);
    }
  }
  
  useEffect(() => {
    if (latitude && longitude && id) {
      getRestaurantMenu();
    }
  }, [latitude, longitude, id]);
  
  return { resDetails, resOffers, resMenu, loading, error };
};

export default useRestaurantMenu;